import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GU_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#GU_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h32v24H0V0z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 4h24v16H4V4z",
      fill: "#4564F9"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5 5h22v14H5V5z",
      stroke: "#CBDAFF",
      strokeOpacity: 0.1,
      strokeWidth: 2
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GU_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 4,
      y: 4,
      width: 24,
      height: 16
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 4h24v16H4V4z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ e.createElement("path", { d: "M5 5h22v14H5V5z", stroke: "#fff", strokeWidth: 2 })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#GU_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.5 5l.607-1.317-.621-.286-.616.297L16.5 5zm0 0a227.2 227.2 0 01.608-1.317h0l.003.002.006.003.019.009a5.472 5.472 0 01.265.131 15.339 15.339 0 012.785 1.858c1.48 1.25 3.264 3.307 3.264 6.067 0 2.731-1.755 4.906-3.21 6.265a17.255 17.255 0 01-2.954 2.203 6.916 6.916 0 01-.059.034l-.018.01-.006.003-.002.001H17.2L16.5 19m0-14l-.63-1.306h-.002l-.002.002-.006.003-.018.009a14.971 14.971 0 00-.953.53c-.562.342-1.318.846-2.081 1.499-1.465 1.252-3.258 3.31-3.258 6.016 0 2.677 1.762 4.853 3.204 6.215a18.063 18.063 0 002.999 2.275l.017.01.006.003.002.002h.001L16.5 19m0 0l.7 1.27-.714.393-.706-.404L16.5 19z",
      stroke: "#C1C9F1",
      strokeOpacity: 0.118,
      strokeWidth: 2.9
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.4 6.037l.687-1.277-.703-.378-.695.391.711 1.264zm0 0l.688-1.277v.001l.003.001.006.003.016.009a4.55 4.55 0 01.207.12 11.7 11.7 0 012.098 1.633c1.124 1.107 2.432 2.89 2.432 5.241 0 2.327-1.286 4.204-2.381 5.398a13.418 13.418 0 01-2.06 1.819 7.728 7.728 0 01-.155.107l-.046.03-.015.01-.005.004-.002.001h-.001s-.001.001-.785-1.219m0-11.88a219.165 219.165 0 00-.711-1.264h-.002l-.002.002-.005.003-.015.009a4.974 4.974 0 00-.205.123 12.263 12.263 0 00-2.084 1.66c-1.11 1.107-2.426 2.89-2.426 5.197 0 2.281 1.293 4.16 2.376 5.354a14.098 14.098 0 002.048 1.846l.153.11.045.03.015.01.005.004.002.001c.001 0 .001.001.806-1.205m0 0l.784 1.22-.799.513-.79-.527.805-1.206z",
      fill: "#CCE0E5"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.4 6.037l.687-1.277-.703-.378-.695.391.711 1.264zm0 0l.688-1.277v.001l.003.001.006.003.016.009a4.55 4.55 0 01.207.12 11.7 11.7 0 012.098 1.633c1.124 1.107 2.432 2.89 2.432 5.241 0 2.327-1.286 4.204-2.381 5.398a13.418 13.418 0 01-2.06 1.819 7.728 7.728 0 01-.155.107l-.046.03-.015.01-.005.004-.002.001h-.001s-.001.001-.785-1.219m0-11.88a219.165 219.165 0 00-.711-1.264h-.002l-.002.002-.005.003-.015.009a4.974 4.974 0 00-.205.123 12.263 12.263 0 00-2.084 1.66c-1.11 1.107-2.426 2.89-2.426 5.197 0 2.281 1.293 4.16 2.376 5.354a14.098 14.098 0 002.048 1.846l.153.11.045.03.015.01.005.004.002.001h0c.001 0 .001.001.806-1.205m0 0l.784 1.22-.799.513-.79-.527.805-1.206z",
      stroke: "#C1C9F1",
      strokeOpacity: 0.748,
      strokeWidth: 2.9
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.4 6.037l.687-1.277-.703-.378-.695.391.711 1.264zm0 0l.688-1.277v.001l.003.001.006.003.016.009a4.55 4.55 0 01.207.12 11.7 11.7 0 012.098 1.633c1.124 1.107 2.432 2.89 2.432 5.241 0 2.327-1.286 4.204-2.381 5.398a13.418 13.418 0 01-2.06 1.819 7.728 7.728 0 01-.155.107l-.046.03-.015.01-.005.004-.002.001h-.001s-.001.001-.785-1.219m0-11.88a219.165 219.165 0 00-.711-1.264h-.002l-.002.002-.005.003-.015.009a4.974 4.974 0 00-.205.123 12.263 12.263 0 00-2.084 1.66c-1.11 1.107-2.426 2.89-2.426 5.197 0 2.281 1.293 4.16 2.376 5.354a14.098 14.098 0 002.048 1.846l.153.11.045.03.015.01.005.004.002.001h0c.001 0 .001.001.806-1.205m0 0l.784 1.22-.799.513-.79-.527.805-1.206z",
      stroke: "#C51918",
      strokeWidth: 2.9
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GU_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 12,
      y: 6,
      width: 9,
      height: 12
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17.332 15.206c-.32.347-.64.645-.92.882a11.006 11.006 0 01-.938-.914c-.916-1.01-1.624-2.207-1.624-3.406 0-1.174.684-2.256 1.575-3.144a9.27 9.27 0 01.988-.852c.29.211.631.487.97.82.876.864 1.567 1.946 1.567 3.176 0 1.254-.713 2.451-1.618 3.438zM15.71 7.312h.001-.001z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17.332 15.206c-.32.347-.64.645-.92.882a11.006 11.006 0 01-.938-.914c-.916-1.01-1.624-2.207-1.624-3.406 0-1.174.684-2.256 1.575-3.144a9.27 9.27 0 01.988-.852c.29.211.631.487.97.82.876.864 1.567 1.946 1.567 3.176 0 1.254-.713 2.451-1.618 3.438zM15.71 7.312h.001-.001z",
        stroke: "#fff",
        strokeWidth: 2.9
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#GU_svg__c)" }, /* @__PURE__ */ e.createElement("path", { fill: "#91CBCB", d: "M12.934 14h7.467v1.5h-7.467z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.602 15.198s5.294.002 5.78-.18c.487-.183-.913 3.507-2.702 3.507s-3.078-3.327-3.078-3.327z",
      fill: "#FDF9A1"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.593 14.755l-.95.732c-1.5-1.948-2.128-3.963-1.86-6.02l1.19.156c-.225 1.723.306 3.425 1.62 5.132z",
      fill: "#A68861"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.393 9.637l-.907 1.063c-.034.04-.099.007-.087-.044l.313-1.326h-1.42c-.054 0-.07-.074-.02-.096l1.213-.531-.86-1.135c-.031-.04.01-.095.057-.077l1.354.528.309-1.244c.012-.05.084-.05.097 0l.307 1.244 1.342-.523c.048-.018.09.039.057.079l-.93 1.128 1.283.531c.05.02.036.096-.02.096h-1.263l.193 1.356c.007.05-.055.078-.088.04l-.93-1.09zM15.6 13h4.8v1.05h-4.8V13z",
      fill: "#239E46"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.873 12.392h-.005a.22.22 0 01-.101.129.384.384 0 01-.21.05.469.469 0 01-.187-.036.395.395 0 01-.147-.109.516.516 0 01-.095-.178.794.794 0 01-.034-.245c0-.091.01-.172.033-.243a.494.494 0 01.096-.178.413.413 0 01.15-.11.49.49 0 01.196-.037c.1 0 .184.022.251.066a.443.443 0 01.155.175l-.11.066a.312.312 0 00-.114-.139.32.32 0 00-.182-.05.34.34 0 00-.135.026.305.305 0 00-.172.186.432.432 0 00-.024.148v.178c0 .055.008.105.024.15a.298.298 0 00.176.187.38.38 0 00.144.026.392.392 0 00.11-.015.27.27 0 00.09-.045.21.21 0 00.062-.075.236.236 0 00.023-.106v-.11h-.247v-.116h.378v.566h-.125v-.16zm.836-.939v.68c0 .106.02.185.059.24.04.053.109.08.208.08.099 0 .168-.027.208-.08a.402.402 0 00.059-.24v-.68h.134v.649c0 .08-.007.15-.021.208a.363.363 0 01-.07.146.285.285 0 01-.125.087.555.555 0 01-.19.028.542.542 0 01-.188-.028.276.276 0 01-.122-.087.36.36 0 01-.067-.146.952.952 0 01-.02-.208v-.649h.135zm1.956 1.1l-.112-.325h-.451l-.113.325h-.136l.39-1.1h.172l.39 1.1h-.14zm-.335-.977h-.008l-.19.536h.386l-.188-.536zm1.85.05h-.007l-.095.185-.267.478-.267-.478-.094-.185h-.008v.927h-.131v-1.1h.179l.32.592h.008l.321-.592h.173v1.1h-.131v-.927z",
      fill: "#C51918"
    }
  ))))
);
export {
  t as default
};
